import React, { createContext, useContext, useState, useEffect } from 'react';
import { API_URL } from '../config/api';

const BrandingContext = createContext();

const defaultBranding = {
  centerName: 'Sports Center',
  tagline: '',
  primaryColor: '#667eea',
  logoUrl: ''
};

export const useBranding = () => {
  const context = useContext(BrandingContext);
  if (!context) {
    // Return default branding if used outside provider
    return { branding: defaultBranding };
  }
  return context;
};

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState(defaultBranding);
  const [loading, setLoading] = useState(true);

  const fetchBranding = async (isRefetch = false) => {
    const token = localStorage.getItem('adminToken');

    // Don't set loading to true on refetch to prevent logo flicker
    if (!isRefetch) {
      setLoading(true);
    }

    try {
      // Use authenticated endpoint if logged in, otherwise use public endpoint
      const url = token ? `${API_URL}/admin/branding` : `${API_URL}/branding/public`;
      const headers = token ? { Authorization: `Bearer ${token}` } : {};

      const response = await fetch(url, { headers });
      const data = await response.json();
      if (data.success && data.settings) {
        setBranding(prev => ({
          ...prev,
          ...data.settings
        }));
      }
    } catch (error) {
      console.log('Using default branding');
    } finally {
      setLoading(false);
    }
  };

  // Wrapper for refetch that doesn't trigger loading state
  const refetchBranding = () => fetchBranding(true);

  useEffect(() => {
    fetchBranding();
  }, []);

  const updateBranding = (newBranding) => {
    setBranding(prev => ({ ...prev, ...newBranding }));
  };

  const value = {
    branding,
    loading,
    updateBranding,
    refetchBranding
  };

  return (
    <BrandingContext.Provider value={value}>
      {children}
    </BrandingContext.Provider>
  );
};
